import { BaseTable, Button, Checkbox, Loading, Modal, TableHeader } from "components"
import { Fragment, useContext, useEffect } from "react"
import { Controller, useForm, useFormContext } from "react-hook-form"
import { useToggle } from "utils"
import { AdjustmentInventoryDetailType, AdjustmentInventoryType } from "../utils"
import toast from "react-hot-toast"
import { LocationContext } from "contexts"
import { useLocationProduct } from "../../CountInventory/utils"
import { PicturesSection } from "pages/Inventori/Register/ItemGroup/components"

export function Item() {
    const { isActive, toggle } = useToggle(false)

    const { trigger } = useFormContext<AdjustmentInventoryType>()
    return (
        <Fragment>
            <Button
                type="button"
                color="primary"
                onClick={() => {
                    trigger(["employee_id", "location_id", "memo"]).then((res) => {
                        if (res) {
                            return toggle()
                        }

                        toast.error("All fields must be required")
                    })
                }}
            >
                SELECT ITEM
            </Button>

            {isActive && <ModalSection toggle={toggle} />}
        </Fragment>
    )
}

function ModalSection(params: {
    toggle: () => void
}): JSX.Element {

    const methods = useFormContext<AdjustmentInventoryType>()
    const locationId = methods.watch("location_id")
    const transactionDate = methods.watch("transaction_date")

    const { control, handleSubmit } = useForm<AdjustmentInventoryDetailType>({
        defaultValues: {
            adjusmentDetail: methods.getValues("adjusmentDetail").map(item => item.product_id)
        }
    })

    const { data: dataLocation } = useContext(LocationContext)
    const location = dataLocation.find(item => item.value === methods.watch("location_id"))?.label
    const { data, isLoading, refetch } = useLocationProduct()


    useEffect(() => {
        if (locationId && transactionDate) {
            refetch(locationId, transactionDate)
        }

        // eslint-disable-next-line
    }, [locationId, transactionDate])


    const onSubmit = (value: AdjustmentInventoryDetailType) => {
        const selectedIds = value.adjusmentDetail.map(item => item)

        const dataProduct = data
            .filter(item => selectedIds.includes(item.product_id))
            .map(item => ({
                product_id: item.product_id,
                mr_unit_id: item.mr_unit_id,
                soh_count: item.soh_count,
                avg_price_use: item.avg_price,
                coa_inventory_id: item.id_coa_asset,
                coa_coex_id: item.id_coa_buy,
                coa_inventory_code: item.coa_asset_code,
                coa_inventory_name: item.coa_asset_name,
                coa_coex_code: item.coa_buy_code,
                coa_coex_name: item.coa_buy_name,
                stock_in: 0,
                stock_out: 0,
                quantity_unit_sell_convention: item.quantity_unit_sell_convention || 1,
                position: 0,
                unit_convention_name: item.unit_convention_name,
                soh: Number(item.soh),
                product_barcode: item.product_barcode,
                product_name: item.product_name,
                mr_unit_name: item.mr_unit_name,
                different_adjustment: 0,
                different_unit: 0,
                amount_adjustment: 0
            }))

        const currentDetails = methods.getValues("adjusmentDetail") || [];

        const mergedDetails = [
            ...currentDetails,
            ...dataProduct.filter(newItem =>
                !currentDetails.some(existing => existing.product_id === newItem.product_id)
            ),
        ];

        methods.setValue("adjusmentDetail", mergedDetails);
        params.toggle()
    }


    return (
        <Modal
            isOpen
            title="LIST ITEM"
            closeModal={params.toggle}
        >
            <Modal.Body>
                <section className="flex flex-col gap-3">
                    <section className="flex md:flex-row flex-col justify-between md:items-end gap-3">
                        <div className="grow w-full">
                            <span className="font-bold">LOCATION: </span> {location}
                        </div>

                        <div className="self-end">
                            <Controller
                                name="adjusmentDetail"
                                control={control}
                                render={({ field }) => {
                                    // Vars
                                    const allChecked: boolean = data.length === field.value.length

                                    return (
                                        <Checkbox
                                            value={allChecked}
                                            onClick={() => {
                                                if (allChecked) {
                                                    return field.onChange([])
                                                }

                                                return field.onChange(data.map(item => item.product_id))
                                            }}
                                        >
                                            All
                                        </Checkbox>
                                    )
                                }}
                            />
                        </div>
                    </section>

                    <BaseTable>
                        <TableHeader>
                            <tr>
                                <th>#</th>
                                <th>ITEM</th>
                                <th>DESCRIPTION</th>
                                <th>PICTURE</th>
                                <th>SOH</th>
                                <th>UNIT</th>
                            </tr>
                        </TableHeader>

                        <Controller
                            name="adjusmentDetail"
                            control={control}
                            render={({ field }) => (
                                <tbody>
                                    {isLoading || !data.length ? (
                                        <tr>
                                            <td colSpan={6}>
                                                <Loading
                                                    errorText="No data available"
                                                    loading={isLoading}
                                                />
                                            </td>
                                        </tr>
                                    ) : data.map((item, key) => {
                                        // Vars
                                        const findItem: number = field.value.findIndex(i => i === item.product_id)
                                        const isChecked: boolean = findItem !== -1

                                        return (
                                            <tr key={key}>
                                                <td>
                                                    <Checkbox
                                                        labelClassName="!justify-center"
                                                        value={isChecked}
                                                        onClick={() => {
                                                            // Vars
                                                            const value = [...field.value]

                                                            if (isChecked) {
                                                                value.splice(findItem, 1)
                                                            } else {
                                                                value.push(item.product_id)
                                                            }

                                                            return field.onChange(value)
                                                        }}
                                                    />
                                                </td>

                                                <td>{item.product_barcode}</td>
                                                <td>{item.product_name}</td>

                                                <td>
                                                    <section className="flex justify-center">
                                                        <div className="w-[400px] lg:w-[200px]">
                                                            <PicturesSection
                                                                className="h-[100px] w-full"
                                                                items={1}
                                                                dataPicture={item.pictures!}
                                                            />
                                                        </div>
                                                    </section>
                                                </td>

                                                <td>{item.soh_count}</td>
                                                <td>{item.mr_unit_name}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            )}
                        />
                    </BaseTable>
                </section>
            </Modal.Body>

            <Modal.Footer>
                <Button
                    color="primary"
                    onClick={handleSubmit(onSubmit)}
                >
                    SELECT
                </Button>
            </Modal.Footer>
        </Modal>
    )
}